import noUiSlider from 'nouislider'
import wNumb from 'wnumb'

import Block from '../block'

export default class RangeSlider extends Block {
	static title = 'range-slider'

	init() {
		const min = parseInt(this.element.dataset.min) ? parseInt(this.element.dataset.min) : 0
		const max = parseInt(this.element.dataset.max) ? parseInt(this.element.dataset.max) : 100

		const minValue = parseInt(this.element.dataset.valueMin) ? parseInt(this.element.dataset.valueMin) : min
		const maxValue = parseInt(this.element.dataset.valueMax) ? parseInt(this.element.dataset.valueMax) : max

		noUiSlider.create(this.element, {
			range: {
				min,
				max,
			},
			step: 1,
			start: [minValue, maxValue],
			margin: 0,
			connect: true,
			orientation: 'horizontal',
			behaviour: 'tap-drag',
			tooltips: true,
			format: wNumb({
				decimals: 0,
			}),
		})

		const input = document.createElement('input')
		input.type = 'hidden'
		input.name = this.element.dataset.name ? this.element.dataset.name : ''

		this.element.appendChild(input)

		const initValues = this.element.noUiSlider.get()

		if (initValues && initValues.length > 1) {
			input.value = `>= ${initValues[0]} |<= ${initValues[1]}`
		}

		this.element.noUiSlider.on('change', values => {
			if (values && values.length > 1) {
				input.value = `>= ${values[0]} |<= ${values[1]}`
				const form = input.closest('.form--autosubmit')
				if (form) {
					form.submit()
				}
			}
		})
	}
}
